import $ from 'jquery';

export default function initM82() {
	//console.log("click");
	$(".view_bio1").click(function(){
		$( "#bio1" ).toggle();
	});
	
	$(".view_bio2").click(function(){
		$( "#bio2" ).toggle();
	});
	
	$(".view_bio3").click(function(){
		$( "#bio3" ).toggle();
	});
	
	$(".view_bio4").click(function(){
		$( "#bio4" ).toggle();
	});
	
	$(".view_bio5").click(function(){
		$( "#bio5" ).toggle();
	});
	
	$(".view_bio6").click(function(){
		$( "#bio6" ).toggle();
	});
	
	$(".view_bio7").click(function(){
		$( "#bio7" ).toggle();
	});
	
	$(".view_bio8").click(function(){
		$( "#bio8" ).toggle();
	});
	
	$(".view_bio9").click(function(){
		$( "#bio9" ).toggle();
	});
	
	$(".view_bio10").click(function(){
		$( "#bio10" ).toggle();
	});
}